import { render, staticRenderFns } from "./tutorHistory.vue?vue&type=template&id=98e5945a&"
import script from "./tutorHistory.vue?vue&type=script&lang=js&"
export * from "./tutorHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports